import { Typography } from "@mui/material";
import { ElementType } from "react";


interface ListTitleProps {
    title: string;
    icon: ElementType;
}

const ListTitle: React.FC<ListTitleProps> = ({ title, icon: IconComponent }) => {
    return (
        <Typography
            variant="subtitle1"
            color="primary"
            fontSize="1.5rem"
            display="flex"
            alignItems="center"
            gap={1}
            flexShrink={0}
        >
            <IconComponent sx={{
                fontSize: '2.6rem',
                color: 'primary.main'
            }} />
            {title}
        </Typography>
    );
};

export default ListTitle;